import { MutableRefObject } from 'react';

import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import { Case } from 'dashboard/models/case';
import { Graph, NodeId } from 'dashboard/models/graph';
import { Backend } from 'dashboard/models/graph-backend';
import { GraphExplorer } from 'dashboard/models/graph-explorer';
import { GraphQuery } from 'dashboard/models/graph-query';
import { GraphQueryTemplate } from 'dashboard/models/graph-query-template';
import { GraphSnapshot } from 'dashboard/models/graph-snapshot';
import { GraphQueryInfo } from 'dashboard/modules/GraphV2/GraphQueryInfo';
import { ModuleGraphV2 } from 'dashboard/modules/GraphV2/model';

export interface StateAndContext {
  // context
  backend: Backend;
  case?: Case;
  excludedNodes: NodeId[];
  g6Wrapper: G6Wrapper;
  graph: Graph;
  graphExplorer: GraphExplorer;
  graphSnapshots: GraphSnapshot[];
  graphQueryTemplates: GraphQueryTemplate[];
  module: ModuleGraphV2;
  // state
  graphQueryOptionIdToGraphQuery: MutableRefObject<{ [token: string]: GraphQuery }>;
  baseGraphQueryToCurrentGraphQuery: MutableRefObject<{ [token: string]: GraphQuery }>;
  graphQueryToGraphQueryInfo: MutableRefObject<{ [token: string]: GraphQueryInfo }>;
  validAttachedGraphQueries: GraphQuery[];
  gqtsToGenerateGraphQueriesFor: GraphQueryTemplate[];
  selectedGraphQueryOptionId: string;
  viewBaseQuery: boolean;
  shouldPollQueries: MutableRefObject<boolean>;
  // actions
  discardOngoingHydrations: () => void;
  forceRerender: () => void;
  setCurrentGraphQuery: (graphQuery: GraphQuery) => void;
  setSelectedGraphQueryOptionId: (graphQueryOptionId: string) => void;
  setIsPerformingRelayout: (isPerformingRelayout: boolean) => void;
  setViewBaseQuery: (viewBaseQuery: boolean) => void;
  setNetworkError: (errorMessage: string) => void;
}

export const isGraphQueryCaseObjectOption = (graphQueryOptionId: string) => {
  return graphQueryOptionId.startsWith('grphq_');
};

export const isGraphQueryTemplateOption = (graphQueryOptionId: string) => {
  return graphQueryOptionId.startsWith('gqt_');
};
